import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, fromEvent, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

export const MOBILE_BREAKPOINT = 768;

@Injectable({
  providedIn: 'root'
})
export class IsMobileService implements OnDestroy {

  private readonly _isMobile = new BehaviorSubject<boolean>(window.innerWidth < MOBILE_BREAKPOINT);
  readonly isMobile$ = this._isMobile.asObservable();

  private readonly resizeSub: Subscription;

  constructor() {
    this.resizeSub = fromEvent(window, 'resize').pipe(
      debounceTime(100),
      map(() => window.innerWidth < MOBILE_BREAKPOINT),
      distinctUntilChanged(),
    ).subscribe(isMobile => this._isMobile.next(isMobile));
  }

  getIsMobile(): boolean {
    return this._isMobile.getValue();
  }

  setIsMobile(isMobile: boolean): void {
    this._isMobile.next(isMobile);
  }

  ngOnDestroy(): void {
    this.resizeSub.unsubscribe();
  }

}
